import React, {Component} from 'react';
import { Drawer, Icon, Tooltip } from 'antd';
import Button from '../../components/uielements/button';
import './NotificationTopbar.css';
import Modal from '../../components/mycomponents/modals/Modal';

class NotificationTopbar extends Component{
  constructor(props){
    super(props);
    this.state={
      visible:false,
      titleNotification:null,
      notificationShowing:null,
      processedIds:[],
    }
  }
  componentDidUpdate(prevProps){
    const prev = prevProps.notifications || [];
    const curr = this.props.notifications || [];
    if(curr.length > 0 && curr !== prev){
      this.handleNotifications([...curr]);
    }
  }
  handleNotifications = (notifications) => {
    if(!notifications || notifications.length === 0) return;
    const notification = notifications[0];
    const remaining = notifications.slice(1);
    const data = this.getStorageNotification();
    if(!data.includes(notification.id)){
      const updated = [...data, notification.id];
      localStorage.setItem('notifications', JSON.stringify(updated));
      this.setState({processedIds: updated}, () => {
        this.showNotificationNew(notification, remaining);
      });
    } else {
      this.handleNotifications(remaining);
    }
  }
  getStorageNotification = () => {
    const data = localStorage.getItem('notifications');
    return data ? JSON.parse(data) : [];
  }
  showNotificationNew = (object, remaining) => {
    this.setState({notificationShowing:object, visible:true});
    setTimeout(() => {
      this.setState({visible:false}, () => {
        setTimeout(() => {
          this.handleNotifications(remaining);
        }, 2000);
      });
    }, 5000);
  }
  onClose = () => {
    this.setState({visible:false});
  }
  showInfo = (object) => {
    this.setState({visible:false, titleNotification:object.asunto}, () => {
      this.toggleModal('modal', {item:object});
    });
  }
  saveRef = (obj, name) => {
    this[name] = obj;
  }
  toggleModal = (name, m, obj=null) => {
    if (this[name] && this[name].toggle) {
      this[name].toggle(m, obj);
    }
  }
  render(){
    const { notificationShowing } = this.state;
    return(
      <Drawer
          placement="top"
          closable={false}
          onClose={this.onClose}
          visible={this.state.visible}
          getContainer={false}
          mask={false}
          height={55}
          style={{ position: 'fixed', backgroundColor: 'unset' }}
          drawerStyle={{backgroundColor:'rgb(242,107,58, 0.95)', borderRadius: '0px 0px 10px 10px'}}
          bodyStyle={{width:'100%', height:'100%'}}
          className="notification"
        >
          {
            notificationShowing ?
            <div style={{width:'100%', height:'100%', display:'flex', alignItems:'center', backgroundColor: 'unset'}}>
            <div style={{width:'100%', display:'flex', justifyContent:'flex-start', alignItems:'center'}}>
            <p style={{margin:0, color:'#fff'}}><b>{notificationShowing.asunto}</b></p>
            </div>
            <div style={{width:'100%', display:'flex', justifyContent:'flex-end', alignItems:'center'}}>
            <Tooltip title={'Ver mas información.'}>
            <Icon style={{marginLeft:10, color:'#fff'}} type="eye" onClick={() => this.showInfo(notificationShowing)}/>
            </Tooltip>
            <Tooltip title={'Eliminar'}>
            <Icon style={{marginLeft:10, color:'#fff'}} type="delete" onClick={() => this.onClose()}/>
            </Tooltip>
            </div>
            </div>
            :null
          }
          <Modal footer={null} closable={true} style={{ top: 20 }} ref={(e) => this.saveRef(e, 'modal')} width={'50%'} Content={Content} title={this.state.titleNotification} okText={'Aceptar'} cancelText={'Cancelar'}/>
        </Drawer>
    )
  }
}

class Content extends Component{
  render(){
    const { item } = this.props;
    return(
      <div className="preview">
        <div dangerouslySetInnerHTML={{ __html: item?item.cuerpo:null }} style={{overflow:'auto'}}/>
      </div>
    )
  }
}

export default NotificationTopbar
